module.exports = require('./gl_ES');